import { useProductPageStore } from '../../contexts/ProductPageStore'

const ProductPageSuspense = ({ children, fallback }) => {
  const hydrated = useProductPageStore((x) => x.isLazyDataHydrated)
  const csrFlag = useProductPageStore((x) => x.csrFlag)
  const isNextLinkLoading = useProductPageStore((x) => x.isNextLinkLoading)

  if ((!hydrated && Number(csrFlag)) || isNextLinkLoading) {
    return fallback ? fallback : null
  }

  return <>{children}</>
}

export default ProductPageSuspense
